import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ElectricityGridOperatorItem {
  city: string
  id: number
  name: string
  postalCode: string
  street: string
}

export interface ElectricityGridOperatorState {
  operators: Array<ElectricityGridOperatorItem>
}

const initialState: ElectricityGridOperatorState = {
  operators: []
}

export const electricityGridOperatorSlice = createSlice({
  name: 'electricitygridoperator',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setElectricityGridOperatorSlice: (
      state,
      action: PayloadAction<Array<ElectricityGridOperatorItem>>
    ) => {
      state.operators = action.payload
    }
  }
})

export const { setElectricityGridOperatorSlice } =
  electricityGridOperatorSlice.actions

export default electricityGridOperatorSlice.reducer
